import React, { useState } from "react";
import ClassInfo from "./ClassInfo.component";
import AddEditClassInfoForm from "./AddEditClassInfoForm.component";

const ClassInfoAndFormContainer = ({ _data, handelEdit, handelDelete }) => {
  const [editData, setEditData] = useState(false);
  const isBlank =
    _data?.sections ||
    _data?.board ||
    (Array.isArray(_data?.affiliationList) &&
      _data?.affiliationList.length > 0) ||
    _data?.totalSeats ||
    _data?.mode;
  const handelUpdateData = (values) => {
    handelEdit(values); //send data to previous component
    setEditData(false);
  };
  const handelDeleteData = (data) => handelDelete(data);
  const handelEditData = () => setEditData(true);

  return !isBlank || editData ? (
    <AddEditClassInfoForm _data={_data} handelOutputData={handelUpdateData} />
  ) : (
    <ClassInfo
      _data={_data}
      handelEdit={handelEditData}
      handelDelete={handelDeleteData}
    />
  );
};

export default ClassInfoAndFormContainer;
